/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.germnetwork.declaration'

type $nsid = typeof $nsid

export { $nsid }

/** A declaration of a Germ Network account */
type Main = {
  $type: 'com.germnetwork.declaration'

  /**
   * Semver version number, without pre-release or build information, for the format of opaque content
   */
  version: string

  /**
   * Controls who can message this account
   */
  messageMe?: MessageMe

  /**
   * Opaque value, an ed25519 public key prefixed with a byte enum
   */
  currentKey: Uint8Array

  /**
   * Opaque value, contains MLS KeyPackage(s), and other signature data, and is signed by the currentKey
   */
  keyPackage?: Uint8Array

  /**
   * Array of opaque values to allow for key rolling
   */
  continuityProofs?: Uint8Array[]
}

export type { Main }

/** A declaration of a Germ Network account */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    version: /*#__PURE__*/ l.string({ maxLength: 14, minLength: 5 }),
    messageMe: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<MessageMe>((() => messageMe) as any),
    ),
    currentKey: /*#__PURE__*/ l.bytes(),
    keyPackage: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.bytes()),
    continuityProofs: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.bytes(), { maxLength: 1000 }),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type MessageMe = {
  $type?: 'com.germnetwork.declaration#messageMe'

  /**
   * A URL to present to an account that does not have its own com.germnetwork.declaration record, must have an empty fragment component, where the app should fill in the fragment component with the DIDs of the two accounts who wish to message each other
   */
  messageMeUrl: l.UriString

  /**
   * The policy of who can message the account, this value is included in the keyPackage, but is duplicated here to allow applications to decide if they should show a 'Message on Germ' button to the viewer.
   */
  showButtonTo: 'none' | 'usersIFollow' | 'everyone' | l.UnknownString
}

export type { MessageMe }

const messageMe = /*#__PURE__*/ l.typedObject<MessageMe>(
  $nsid,
  'messageMe',
  /*#__PURE__*/ l.object({
    messageMeUrl: /*#__PURE__*/ l.string({
      format: 'uri',
      maxLength: 2047,
      minLength: 1,
    }),
    showButtonTo: /*#__PURE__*/ l.string<{
      maxLength: 100
      minLength: 1
      knownValues: ['none', 'usersIFollow', 'everyone']
    }>({ maxLength: 100, minLength: 1 }),
  }),
)

export { messageMe }
